import { atom } from 'jotai'
import { getUrlParams } from '../utils/url'

export interface IUrlParams {
  editorial: string | null
}

export const urlParams = atom<IUrlParams>(getUrlParams())
